import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { TextAndIconsSliceFragment } from "../../types/graphql";
import { IPageContext } from "../../types/types";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { TextAndIconsBase } from "./text-and-icons.styled";

export type ITextAndIconsProps = Slice<
  SharedSliceType,
  TextAndIconsSliceFragment["primary"],
  TextAndIconsSliceFragment["items"][number]
> & { type: SharedSliceType.text_and_icons };

const TextAndIcons = ({
  slice,
}: SliceComponentProps<ITextAndIconsProps, IPageContext>) => {
  // console.log("TextAndIcons slice", slice);
  const { primary, items } = slice;

  return (
    (slice && (
      <TextAndIconsBase
        className="slice-section tight"
        style={{
          background: `linear-gradient(133deg, #0E6AED 14.67%, #2437BF 71.41%)`,
        }}
      >
        <div className="container">
          <div className="grid">
            <div className="col-span-4 lg-col-span-6 content-center">
              <PrismicRichText
                field={primary.primary_heading.richText}
                components={htmlSerializer}
              />
              {primary.primary_description && (
                <PrismicRichText
                  field={primary.primary_description.richText}
                  components={htmlSerializer}
                />
              )}
            </div>
            <div className="col-span-4 lg-col-span-6">
              <ul>
                {items &&
                  items.map((item) => (
                    <li>
                      <GatsbyImage
                        image={item.icon?.gatsbyImageData}
                        alt={item.icon?.alt || "Xometry Resources"}
                        loading="lazy"
                      />
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </TextAndIconsBase>
    )) || <></>
  );
};
export default TextAndIcons;
